import {Banner} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import {useShopLocalesAndMarkets} from 'utilities/use-shop-locales-and-markets';

const I18N_SCOPE = 'UntranslatedNotificationBanner';

export const UntranslatedNotificationBanner = () => {
  const [i18n] = useI18n();
  const {currentLocale: currentShopLocale, primaryLocale: primaryShopLocale} =
    useShopLocalesAndMarkets();

  return (
    <Banner
      tone="info"
      title={i18n.translate('title', {
        scope: [I18N_SCOPE],
      })}
    >
      <p>
        {i18n.translate(
          'content',
          {scope: [I18N_SCOPE]},
          {
            primaryLanguage: primaryShopLocale?.name ?? '',
            selectedLanguage: currentShopLocale?.name ?? '',
          },
        )}
      </p>
    </Banner>
  );
};
